import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

class NavItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showOptions: false,
		};
	}

	toggleOptions = e => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({ showOptions: !this.state.showOptions });
	};

	getOptionsWidth() {
		const { showOptions, deleteItem } = this.props;
		let count = 0;
		if (showOptions) {
			count = count + 1;
			if (deleteItem) {
				count = count + 1;
			}
		}
		return `on on-${count}`;
	}

	copyItem = e => {
		e.preventDefault();
		e.stopPropagation();
		this.props.history.push(this.props.copyTo);
		this.setState({ showOptions: false });
	};

	deleteItem = e => {
		const { text, id } = this.props;
		e.preventDefault();
		e.stopPropagation();

		this.props.deleteItem(id, text);
		this.setState({ showOptions: false });
	};

	render() {
		//var path = this.props.location.pathname;
		//const active = path.startsWith(this.props.linkTo) || this.props.isActive;
		const { icon, deleteItem, text } = this.props;
		return (
			<li className={this.props.isActive ? "active" : ""}>
				<Link to={this.props.linkTo} className="">
					{this.props.showOptions && (
						<div className="options-popout">
							<div
								className={`coverall ${this.state.showOptions ? "on" : ""}`}
								onClick={e => this.toggleOptions(e)}
							></div>
							<div
								className={`collection-options ${this.state.showOptions ? this.getOptionsWidth() : ""}`}
							>
								<div className="collection-option" title="Duplicate" onClick={e => this.copyItem(e)}>
									<i className="fal fa-copy"></i>
								</div>
								{deleteItem && (
									<div className="collection-option" title="Delete" onClick={e => this.deleteItem(e)}>
										<i className="fal fa-trash"></i>
									</div>
								)}
							</div>
							<div
								className={`settings-dots btn-circle ${this.props.isActive ? "" : "dark"}`}
								onClick={e => this.toggleOptions(e)}
							>
								<i className="fal fa-ellipsis-v icon"></i>
							</div>
						</div>
					)}
					{icon && <i className={"fal fa-" + this.props.icon}></i>}
					<span>{text}</span>
				</Link>
			</li>
		);
	}
}
NavItem.propTypes = {
	linkTo: PropTypes.string,
	copyTo: PropTypes.string,
	icon: PropTypes.string,
	text: PropTypes.string,
	location: PropTypes.object,
	isActive: PropTypes.bool,
	showOptions: PropTypes.bool,
	deleteItem: PropTypes.func,
	id: PropTypes.string,
};
export default withRouter(NavItem);
